"use client"
import { useTranslations } from "next-intl";
import Reveal from "./Reveal"
import { motion } from 'framer-motion';
import Link from "next/link";

export default function HeroSection() {
    const t = useTranslations('enterprise');
    return (
        <section className="h-screen max-lg:h-auto -mt-[78px] overflow-hidden" 
            style={{
                background: "linear-gradient(to top right, #EEF1FE 0%, transparent 45%, transparent 100%)"
            }}>
            <div className="flex max-lg:flex-col max-w-[1440px] mx-auto h-full">
                <div className="lg:pl-[78px] max-sm:px-4 sm:max-w-[716px] sm:min-w-[416px] mt-[248px] max-lg:mt-[136px] max-lg:text-center mx-auto">
                    <Reveal 
                        delay={0.1} 
                        duration={0.8} 
                        direction="left"
                        withBlur={true}
                        blurAmount={8}
                    >
                        <h1 className="text-[56px]/[64px] max-lg:text-[48px]/[56px] max-sm:text-[32px]/[40px] font-normal tracking-[-2px]">{t('the-diamond')}<br/>{t('resource-of-the-ai-age')}</h1>
                    </Reveal>
                    <Reveal 
                        delay={0.5} 
                        duration={0.8} 
                        direction="left"
                        withBlur={true}
                        blurAmount={8}
                    >
                        <p className="mt-5 text-lg max-lg:text-base max-sm:text-sm font-light">{t('revolutionizes-enterprise-and-government-ai-adoption-with-cost-effective-secure-and-scalable-solutions')}</p>
                    </Reveal>
                    <Link href={"/news"}>
                    <motion.div
                        initial={{ opacity: 0, translateY: 40 }}
                        whileInView={{ opacity: 1, translateY: 0 }}
                        transition={{ duration: 1, ease: 'easeOut' }}
                        viewport={{ once: true }}             
                    >
                        <button className="mt-[66px] max-lg:mt-[48px] bg-[#06F] rounded-[12px] px-4 py-2 text-white text-base font-medium">
                            {t('case-studies')}
                        </button>
                    </motion.div>
                    </Link>
                </div>
                <video
                    autoPlay 
                    loop 
                    muted 
                    playsInline
                    className="max-h-[800px] xl:-translate-y-20 max-lg:scale-100 rounded-full
                            [mask-image:radial-gradient(circle_at_center,black_15%,transparent_80%)]
                            [-webkit-mask-image:radial-gradient(circle_at_center,black_15%,transparent_80%)]"
                >
                    <source src="https://cdn-r2.hyra.network/hyra-network/hero-interpise.webm" type="video/webm" />
                </video>
            </div>
        </section>
    )
}